import BlockTextListColumnData from './BlockTextListColumnData';
import BlockComponentImage from '../../../models/BlockComponentValues/BlockComponentImage';

class BlockTextListData {
  columns?: BlockTextListColumnData[];
  url?: BlockComponentImage;
}

// eslint-disable-next-line @typescript-eslint/no-namespace
namespace BlockTextListData {
  export function make(columns: BlockTextListColumnData[], url?: string): BlockTextListData {
    return {
      columns,
      url: BlockComponentImage.make(url),
    };
  }

  export function getDefault(): BlockTextListData {
    return make(
      [
        BlockTextListColumnData.getDefault(),
        BlockTextListColumnData.getDefault(),
      ],
    );
  }
}

export default BlockTextListData;
